<template>
  <button
    v-bind="$attrs"
    type="button"
    class="inline_button"
    :class="{ 'inline_button--grey': grey }"
    @click="$emit('click', $event)"
    :disabled="disabled"
  >
    <slot name="icon"></slot>
  </button>
</template>

<script>
export default {
  /**
   * @vuese
   * Button to be used specifically next to an input-like component
   */
  name: "InlineButton",
  props: {
    // Turn apply the html native disabled attribute along with corresponding styling
    disabled: {
      type: Boolean,
      default: false,
    },
    // Apply the grey styling for this input.
    grey: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~include-media";
@import "../../style_variables/style_variables.scss";

.inline_button {
  font-size: 1rem;
  border-radius: 4px;
  border: 0;
  margin-left: 16px;
  height: 56px;
  min-width: 56px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: $navy;
  color: $white;

  @include media("<tablet") {
    min-width: 44px;
  }

  &:hover {
    background-color: #2d3f8e;
  }

  &:active {
    background-color: #3e53ac;
  }

  &:disabled {
    color: $white;
    background-color: $grey_french;

    &:hover {
      cursor: default;
    }
  }

  &.inline_button--grey {
    color: $grey_french;
    background-color: transparent;

    &:hover {
      color: $grey_manatee;
      background-color: $grey_alabaster;
      transition: all 0.3s;
    }
  }
}
</style>
